import { grey, TeamIcon } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { nounPluralize } from "@utils/data-display";
import { getPendingUserIcon, getPrettyName } from "@utils/user-utils";
/** Create autocomplete options based on SdbMemberTypes */
export function createMemberOption({
  member,
  isDisabled = false,
  disabledMessage = "",
  isPreselected = false
}) {
  return {
    isDisabled,
    disabledMessage,
    isPreselected,
    title: getPrettyName(member),
    subtitle: FaroCoreApiUtils.Member.isMemberActive(member) ? member.email : "",
    value: member.identity,
    avatarImage: member.thumbnailUrl ?? "",
    avatarIcon: getPendingUserIcon(member)
  };
}
/** Create autocomplete options based on ITeam */
export function createTeamOption({
  team,
  isDisabled = false,
  disabledMessage = "",
  isPreselected = false
}) {
  return {
    isDisabled,
    disabledMessage,
    isPreselected,
    title: team.name,
    subtitle: `${nounPluralize({
      counter: team.memberCount,
      word: "member"
    })}`,
    value: team.id,
    avatarIcon: <TeamIcon />,
    avatarStyle: {
      bgcolor: grey[700]
    }
  };
}